import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import './css/App.css';
import CorePage from './views/core/CorePage';
import ErrorPage from './views/core/ErrorPage';
import Scorecard from './views/scorecard/Scorecard';
import Home from './views/plp/Home';
import Dashboard from './views/dashboard/Dashboard';
import Settings from './views/settings/Settings';
import LessonView from './views/lesson/LessonView';
//import PreloginHome from './prelogin/src/PreloginHome';
import ResetPasswordForm from './views/login/ResetPasswordForm';
import ExternalLogin from './views/extlogin/ExternalLogin';
import LumosLogin from './views/extlogin/LumosLogin';
import VendorLogin from './views/extlogin/VendorLogin'; 
import OpenLessonView from './views/lesson/OpenLessonView';
import ms_PreloginHome from './vendors/mindstretcher/ms_PreloginHome';
import sg_PreloginHome from './views/sg/sg_PreloginHome';

import ComponentRegistry from './model/ComponentRegistry';
import UserStorageUtil from './util/UserStorageUtil';
import UserStore from './util/UserStore';

import MozartView from './views/lesson/MozartView';

import TestComplete from './views/temp/TestComplete';
import './track/CouponTracker';
import za_PreloginHome from './views/za/za_PreloginHome';


class App extends CorePage {

  constructor(props){
    super(props);
    this.userStore = new UserStore();
  }

  getCmpHelper(){
    return super.getCmpHelper(this.userStore);
  }

  getComponent(cmpName){
    return this.getCmpHelper().getCmp(cmpName);
  }

  getComponentByName(cmpName, altCmpName){
    return this.getCmpHelper().getCmpByName(cmpName, altCmpName);
  }

  getLandingByGeo(cmpName){
    const geoCookie = this.getGeo();
    
    if(cmpName && geoCookie){
      return this.getComponentByName(geoCookie.toLowerCase()+"_"+cmpName, cmpName);
    }
    
    return this.getComponent(cmpName);
  }

  render() {
    return (
      <Router>
      <Switch>
      {/*<Route path="/sg" component={this.getComponentByName("sg_PreloginHome","PreloginHome")}/> 
      <Route path="/in" component={this.getComponentByName("in_PreloginHome","PreloginHome")}/> 
      <Route path="/za" component={this.getComponentByName("za_PreloginHome","PreloginHome")}/>
      <Route path="/" exact component={this.getLandingByGeo("PreloginHome")}/>*/} 
      
      <Route path="/" exact component={this.getComponentByName("za_PreloginHome","PreloginHome")}/>
      <Route path="/home" exact component={this.getComponentByName("za_PreloginHome","PreloginHome")} />
      <Route path='/login' exact component={this.getComponentByName("za_PreloginHome","PreloginHome")}/>
      <Route path="/lessonview/:id" exact component={LessonView} />   
      <Route path="/mozartview/:lid" exact component={MozartView} />  
      <Route path="/openlessonview/:id" exact component={OpenLessonView} /> 
      <Route path="/forgotPassword/:id" exact component={ResetPasswordForm} />
      <Route path="/extlogin" component={ExternalLogin} />
      <Route path="/lumos" component={LumosLogin} />
      <Route path="/vendorlogin" component={VendorLogin} />
      <Route path="/800" exact component={TestComplete} />
      {/*<Route path="/404" exact component={ErrorPage} />*/}
      <Route component={this.getLandingByGeo("PreloginHome")} />
      <Redirect from='*' to='/' />
      </Switch>
      </Router>
	  
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js